import apiClient from './api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export interface VerificationCodeRequest {
  email: string;
}

export interface VerifyCodeRequest {
  email: string;
  code: string;
}

export interface VerifyCodeResponse {
  verificationToken: string;
}

export interface ResetPasswordRequest {
  email: string;
  password: string;
  verificationToken: string;
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      '/auth/login',
      credentials
    );
    return response.data;
  },

  requestVerificationCode: async (request: VerificationCodeRequest): Promise<void> => {
    await apiClient.post('/members/register/verification-code', request);
  },

  verifyCode: async (request: VerifyCodeRequest): Promise<VerifyCodeResponse> => {
    const response = await apiClient.post<VerifyCodeResponse>('/members/register/verification-code/verify', request);
    return response.data;
  },

  requestPasswordVerificationCode: async (request: VerificationCodeRequest): Promise<void> => {
    await apiClient.post('/auth/password/verification-code', request);
  },

  verifyPasswordCode: async (request: VerifyCodeRequest): Promise<VerifyCodeResponse> => {
    const response = await apiClient.post<VerifyCodeResponse>('/auth/password/verification-code/verify', request);
    return response.data;
  },

  resetPassword: async (request: ResetPasswordRequest): Promise<void> => {
    await apiClient.post('/members/password/reset', {
      email: request.email,
      password: request.password,
      verificationToken: request.verificationToken
    });
  },

  logout: async (): Promise<void> => {
    const refreshToken = localStorage.getItem('refreshToken');

    // API 호출 시도 (실패해도 로그아웃 진행)
    try {
      if (refreshToken) {
        await apiClient.delete('/auth/logout', {
          data: { refreshToken }
        });
      }
    } catch (error) {
      console.error('Logout API call failed:', error);
      // 에러를 무시하고 계속 진행
    }

    // 토큰 삭제 및 리다이렉트
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('guestMode');
    window.location.href = '/login';
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('accessToken');
  },
};
